// The add-option row is a real Combobox.Item so base-ui owns its highlight and
// keyboard reach alongside the options. It rides in the item list under a
// reserved value, and option-shaped code filters it back out.
export const ADD_OPTION_VALUE = '__select_add_option__';

export type AddOptionItem = {
  value: typeof ADD_OPTION_VALUE;
  label: string;
  href: string;
};

export const isAddOptionItem = (item: { value: unknown }): item is AddOptionItem =>
  item.value === ADD_OPTION_VALUE;
